import loadjs from 'loadjs';
import logger from '../ErrorBoundary/logger';
import { safeTechScript } from './index';

export const safetechInit = (safetechSessionId) => {
  if (safetechSessionId) {
    loadjs(safeTechScript(safetechSessionId), { returnPromise: true })
      .then(() => {
        if (window?.ka?.ClientSDK) {
          window.client = new window.ka.ClientSDK();
          if (window?.client?.autoLoadEvents) {
            window.client.autoLoadEvents();
          }
        }
      })
      .catch(() => {
        console.warn(new Error('Safetech JS failed to load'));
        logger({
          message: `Safetech JS failed to load with URL ->${safeTechScript(safetechSessionId)}`,
          eventType: 'SafetechJS',
          json: true,
        });
      });
  } else {
    console.info({
      message: 'Safetech session id is missing',
      eventType: 'SafetechJS',
      json: true,
    });
  }
};
